import { createFileRoute } from '@tanstack/react-router'

import { DataWarehousePage } from '#/modules/data-warehouse/back-office/data-warehouse-page/data-warehouse-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/admin/data-warehouse/')({
  beforeLoad: (options) => requirePermissions(options, ['session.access']),
  component: DataWarehousePage,
})
